export const dataLayerEvents = {
	// pageView: (url, title) =>
	// 	window.dataLayer &&
	// 	window.dataLayer.push({
	// 		event: 'virtualPageview',
	// 		virtualPageURL: url,
	// 		virtualPageTitle: `${title} page`,
	// 	}),
	onTop: () =>
		window.dataLayer &&
		window.dataLayer.push({
			hostname: 'ynet.co.il',
			page: 'matriculation-certificate-top-iframe',
			title: 'נתוני בגרויות - דירוג',
		}),
	onComparison: () =>
		window.dataLayer &&
		window.dataLayer.push({
			hostname: 'ynet.co.il',
			page: 'matriculation-certificate-compression-iframe',
			title: 'נתוני בגרויות - השוואה',
		}),
};
